import React from 'react';
import PropTypes from 'prop-types';

import DateComponent from "components/List/components/Date";
import Hour from "components/List/components/Hour";
import StatusBadge from "../../../feed/components/StatusBadge";

FeedImport.propTypes = {
    retailer: PropTypes.object.isRequired,
};

function FeedImport({retailer}) {
    const lastFeedUpdate = retailer.lastFeedUpdate;

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '4px',
        }}>
            {lastFeedUpdate && (
                <div style={{display:'flex', flexDirection: 'column', lineHeight: '1'}}>
                    <DateComponent date={lastFeedUpdate} />
                    <Hour date={lastFeedUpdate} />
                </div>
            )}
            <StatusBadge process={retailer.importingFeeds ? 'importing-products' : 'idle'} />
        </div>
    );
}

export default FeedImport;
